import React from "react";
import { RotateCw, Headphones } from "lucide-react";
import { TOK, SERIF, SANS, PrimaryBtn, QuietLink, Title, flattenLines } from "./shared";

const KEY = "soulumo_last_create";
export const loadLastCreate = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };
export const saveLastCreate = (v) => localStorage.setItem(KEY, JSON.stringify(v));

const VOICE_WORDS = { mine: "Your voice", female: "Soulumo voice", male: "Soulumo male voice" };

export const RepeatCard = ({ last, onRepeat }) => (
  <button type="button" onClick={onRepeat} data-testid="simple-repeat-card"
    className="w-full text-left rounded-2xl p-5 flex items-center gap-4 transition-[transform,border-color] duration-200 active:scale-[0.99]"
    style={{ background: "rgba(215,187,122,0.08)", border: `1px solid ${TOK.gold}` }}>
    <span className="w-11 h-11 shrink-0 rounded-full inline-flex items-center justify-center" style={{ background: TOK.gold, color: TOK.ink }}>
      <RotateCw size={17} />
    </span>
    <span className="min-w-0">
      <span className="block text-lg" style={{ color: TOK.cream, fontFamily: SERIF }}>Make another like last time</span>
      <span className="block text-xs truncate" style={{ color: TOK.creamMist, fontFamily: SANS }} data-testid="simple-repeat-card-sub">
        {VOICE_WORDS[last.voice] || "Your voice"} · {last.journey_name} · fresh words
      </span>
    </span>
  </button>
);

export const RepeatStep = ({ plan, sections, voice, minutes, onCreate, onReview, error }) => {
  const lines = flattenLines(sections).slice(0, 3);
  return (
    <div className="space-y-7" data-testid="simple-repeat-step">
      <div>
        <div className="text-[0.62rem] uppercase tracking-[0.3em]" style={{ color: TOK.goldSoft, fontFamily: SANS }}>{plan.journey_name}</div>
        <div className="mt-2"><Title>Fresh words, ready to go</Title></div>
      </div>
      <ul className="space-y-2" data-testid="simple-repeat-preview">
        {lines.map((t, i) => <li key={i} className="text-lg italic" style={{ color: TOK.creamDim, fontFamily: SERIF }}>{t}</li>)}
      </ul>
      <p className="text-[0.62rem] uppercase tracking-[0.26em]" style={{ color: TOK.goldSoft, fontFamily: SANS }} data-testid="simple-repeat-summary">
        {VOICE_WORDS[voice] || "Your voice"} · same journey · {minutes} minutes
      </p>
      {error && <p className="text-sm" style={{ color: "#e9a39c", fontFamily: SANS }} data-testid="simple-repeat-error">{error}</p>}
      <PrimaryBtn testId="simple-repeat-create" onClick={onCreate}><Headphones size={16} /> Create my installation</PrimaryBtn>
      <QuietLink testId="simple-repeat-review" onClick={onReview}>Read all the words first</QuietLink>
    </div>
  );
};
